<template>
  <div id="table-container" class="table-responsive">
    <table
      class="table table-borderless table-hover"
      :style="`width: ${table_width ? table_width : '100%'}`"
    >
      <thead>
        <tr>
          <th v-if="multiSelect" scope="col" class="header-cell">
            <b-check
              size="lg"
              id="select-all"
              v-model="selectAll"
              name="select-all"
            />
          </th>
          <th
            scope="col"
            v-for="(column, index) in table_columns"
            :key="index"
            class="header-cell"
          > 
            <div class="align-center">
              <div
                v-if="column.header_cell"
                v-html="column.header_cell(column.header)"
              >
              </div>
              <div
                :class="['sorting-icon', {'text-dark': column.sortValue === sortField}]"
                @click="sortData(column.sortValue, column.sortType)"
              >
                {{ column.header }}
                <span v-if="haveSort">
                  <i
                    class="las la-sort la-lg"
                    v-if="column.sortValue !== sortField"
                  ></i>
                  <i
                    class="las la-sort-up la-lg"
                    v-if="column.sortValue === sortField && modifier === 1"
                  ></i>
                  <i
                    class="las la-sort-down la-lg"
                    v-if="column.sortValue === sortField && modifier === -1"
                  ></i>
                </span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(record, record_index) in table_data"
          :class="['table-row', {'row-highlighted': rowHighlightFunction(record)}]" 
          :key="record_index"
        >
          <td v-if="multiSelect" class="column-cell">
            <b-check
              size="lg"
              :id="`select-${record_index}`"
              :name="`select-${record_index}`"
              :checked="selectAll"
            />
          </td>
          <td
            v-for="(column, column_index) in table_columns"
            :key="column_index"
            class="column-cell"
            :style="`width:${column.width ? column.width : 'auto'};`"
            @click="rowClick(record)"
          >
            <div
              :class="[
                'flex-between',
                {'tooltipclass' : column.header == 'CONTACT'},
              ]"
              :style="column.columnStyle"
            >
              <!-- <div
                v-if="column.cell"
                v-html="
                  column.cell(record[column.accessor], record, record_index)
                "
              ></div> -->
              <div
                v-if="column.htmlCallback"
                v-html="
                  column.htmlCallback(record[column.displayValue])
                "
              ></div>
              <div
                v-else-if="column.html"
                v-html="record[column.displayValue]"
              ></div>
              <div v-else>
                {{ record[column.displayValue] }}
              </div>
              <span v-if="column.header == 'CONTACT'" class="tooltiptext"> {{ record.contact_email }}</span>
              <div
                v-if="column.withActionBtn"
                class="position-relative"
              >
                <base-menu
                  :record="record"
                  :tableActions="tableActions"
                  :record_index="record_index"
                  :table_data="table_data"
                  :tableIndex="tableIndex"
                />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="data && data.length===0">
        <tr class="no-data-container pt-5">
          <div class="no-data-text">
            <div class="las la-meh la-5x pb-1" ></div>
            No data to show. 
          </div>
        </tr>
      </tbody>
    </table>

    <base-pagination
      v-if="havePagination"
      :activePage="activePage"
      :totalRows="totalRows"
      @set-page="setPage"
      :tableName="tableName"
    ></base-pagination>
  </div>
</template>

<script>
import BasePagination from "./BasePagination.vue";
import BaseMenu from "./BaseMenu.vue";

import { QUERY_PARAMETERS } from '@/constants';

export default {
  name: "base-table",
  components: { BasePagination, BaseMenu },
  props: {
    tableIndex: {
      type: String,
      required: false
    },
    tableActions: {
      type: Array,
    },
    tableName: {
      type: String,
      required: false
    },
    table_width: {
      type: String,
    },
    haveSort: {
      type: Boolean,
      required: false,
    },
    defaultSortField: {
      type: String,
      required: false,
    },
    defaultSortType: {
      type: String,
      required: false,
    },
    rowClick: {
      type: Function,
      required: false,
    },
    multiSelect: {
      type: Boolean,
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    havePagination: {
      type: Boolean,
      required: true,
    },
    paginationNavFunction: {
      type: Function,
      required: false,
    },
    activePage: {
      type: Number,
      required: false,
    },
    totalRows: {
      type: Number,
      required: false,
    },
    getAccount: {
      type: Function,
      required: false,
    },
    rowHighlightFunction: {
      type: Function,
      required: false,
      default: () => {return false;},
    },
    receivableProperty: {
      type: String,
      required: false,
      default: "",
    }
  },
  data() {
    return {
      open_menu_index: null,
      icon_hover_index: null,
      selectAll: null,
      sortField: null,
      sortType: this.defaultSortType,
      modifier: null,
    };
  },
  mounted() {
    var sort = this.$route.query[QUERY_PARAMETERS.SORT];
    this.sortField = sort && sort.replace('-', '') || this.defaultSortField;
    this.modifier = (sort && this.$route.query[QUERY_PARAMETERS.SORT].includes("-")) ? -1 : 1;
  },
  watch: {
    sortField(sortField) {
      if (sortField){
        var sort = this.$route.query[QUERY_PARAMETERS.SORT];
        this.modifier = sort && sort.includes("-") ? -1 : 1;
      }
    }
  },
  computed: {
    table_columns() {
      return this.columns.filter(col => col && col.shouldRender());
    },
    table_data() {
      return this.data;
    }
  },
  methods: {
    sortData(columnValue, columnType) {
      if (this.sortField === columnValue) {
        this.modifier *= -1;
      } else {
        this.sortField = columnValue;
        this.sortType = columnType;
        this.modifier = 1;
      }
      if (this.modifier == -1){
        columnValue = `-${columnValue}`;
      }
      this.$route.query[QUERY_PARAMETERS.SORT] = columnValue;
      this.$emit("column-sort", columnValue);
    },
    setPage(pageNoOrType) {
      this.paginationNavFunction(pageNoOrType);
    },
    openMenu(invoice) {
      print(invoice);
    }
  },
};
</script>

<style scoped lang="scss">
@import './BaseTable.scss';
</style>
